import { render, staticRenderFns } from "./DnPreviousStatement.vue?vue&type=template&id=08c404ad&scoped=true&"
import script from "./DnPreviousStatement.vue?vue&type=script&lang=js&"
export * from "./DnPreviousStatement.vue?vue&type=script&lang=js&"
import style0 from "./DnPreviousStatement.vue?vue&type=style&index=0&id=08c404ad&lang=scss&scoped=true&"
import style1 from "./DnPreviousStatement.vue?vue&type=style&index=1&id=08c404ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c404ad",
  null
  
)

export default component.exports